// src/apiClient.js

import axios from 'axios';

// 1. Create a new Axios instance
const apiClient = axios.create({
  baseURL: 'https://api.horizon.co.zm/api' // Your backend API base URL
});

// 2. Add a request interceptor
// This function will run BEFORE every request is sent
apiClient.interceptors.request.use(
  (config) => {
    // 3. Get the token from localStorage
    const token = localStorage.getItem('token');
    
    // 4. If the token exists, add it to the Authorization header
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    
    return config;
  },
  (error) => {
    // Handle request errors
    return Promise.reject(error);
  }
);

export default apiClient;